import { IconProp } from '@fortawesome/fontawesome-svg-core'
import { faTimesCircle } from '@fortawesome/pro-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { TripContext } from 'contexts'
import React, { FC, useContext } from 'react'
import { FilteredLicensePlate, LicensePlate, LicensePlateItem, OrderItem, OrderLicensePlate } from 'services/types'
import './filtered-detail-info.scss'

type Props = {
    licensePlate: LicensePlate,
    onClickRemoveLp: (lp: FilteredLicensePlate) => void
}

export const FilteredDetailInfo: FC<Props> = ({ licensePlate, onClickRemoveLp }) => {
    const tripContext = useContext(TripContext)
    const orderLicensePlates: OrderLicensePlate[] = tripContext.orderLicensePlates.filter(olp => olp.licensePlateId === licensePlate.id)
    const licensePlateItems: LicensePlateItem[] = tripContext.licensePlateItems.filter(lpi => lpi.licensePlateId === licensePlate.id)
    const licencePlateOrderItems: OrderItem[] = tripContext.orderItems.filter(oi => licensePlateItems.some(lpi => lpi.lineItemId === oi.lineItemId))
    const orderItems: OrderItem[] = licencePlateOrderItems.filter(item => orderLicensePlates.some(olp => olp.orderId === item.orderId))
    const itemsNotVerified = orderItems.filter(oi => oi.verifiedMethod == null)
    const itemsVerified = orderItems.filter(oi => oi.verifiedMethod != null)
    const isAllItemVerified = itemsNotVerified.length === 0

    return (
        <div className='filtered-content'>
            <div className={'filtered-content-item'}>{licensePlate.id}</div>
            {isAllItemVerified ?
                <div className={'filtered-content-subheading-fade'}>Complete</div>
                :
                <div className={'filtered-content-count'}>{itemsVerified.length}/{orderItems.length} Verified</div>
            }
            <div className={'filtered-content-delete'} onClick={() => onClickRemoveLp({ id: licensePlate.id, stopId: licensePlate.stopId })}>
                <FontAwesomeIcon icon={faTimesCircle as IconProp} color='grey' size='2x' />
            </div>
        </div>
    )
}

